import { render, staticRenderFns } from "./ConfirmAccountChangeRequest.vue?vue&type=template&id=532a562d&scoped=true"
import script from "./ConfirmAccountChangeRequest.vue?vue&type=script&lang=js"
export * from "./ConfirmAccountChangeRequest.vue?vue&type=script&lang=js"
import style0 from "./ConfirmAccountChangeRequest.vue?vue&type=style&index=0&id=532a562d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a562d",
  null
  
)

export default component.exports